import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

/**
 * Headset with mic: the Help & feedback tab. Same hairline stroke as the other rail icons.
 * The artwork is a plain group (not a nested <svg>) so each variant can set its own viewBox;
 * SvgIcon would otherwise hoist a child svg's viewBox over the prop. `fill="none"` on the group
 * is needed because SvgIcon paints `fill: currentColor` on the root when the child is not an svg.
 * non-scaling-stroke keeps the line 1.2px when the tab variant scales the artwork up.
 */
const HeadsetArtwork = (
    <g fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4.5 12v-1.25a7.5 7.5 0 0 1 15 0V12" vectorEffect="non-scaling-stroke" />
        <path d="M8.6 9.3a4.9 4.9 0 0 1 4.5-1.6" vectorEffect="non-scaling-stroke" />
        <rect x="2.75" y="11.75" width="3.5" height="6.5" rx="1.5" vectorEffect="non-scaling-stroke" />
        <rect x="17.75" y="11.75" width="3.5" height="6.5" rx="1.5" vectorEffect="non-scaling-stroke" />
        <path d="M4.5 18.25v.5a3.25 3.25 0 0 0 3.25 3.25h2.35" vectorEffect="non-scaling-stroke" />
        <circle cx="11.35" cy="22" r="1.25" vectorEffect="non-scaling-stroke" />
    </g>
)

const HeadsetIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        {HeadsetArtwork}
    </SvgIcon>
)

/**
 * Right-rail tab variant: the tab icons are 40px boxes whose 48-unit artwork covers ~23px, so a
 * 34-unit viewBox lands the 20-unit headset on the same drawn size (20 × 40 / 34 ≈ 23.5px).
 */
export const HeadsetTabIcon: React.FC<SvgIconProps> = ({ style, ...props }) => (
    <SvgIcon viewBox="-5 -5 34 34" {...props} style={{ fontSize: '40px', ...style }}>
        {HeadsetArtwork}
    </SvgIcon>
)

export default HeadsetIcon
